import { Component, OnInit, Output, EventEmitter, SimpleChanges, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { ModalController, Platform, PopoverController, NavParams, AlertController, MenuController, NavController} from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/service/user.service';
import { ObjetService } from 'src/app/service/objet.service';
import { InjectedContext, Context } from 'src/app/shared/services/context.service';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { ImageViewerComponent } from 'src/app/components/views-photos/image-viewer/image-viewer.component';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as sha1 from 'sha1';
import { objet } from 'src/app/model/objet.model';
import { SmilersService } from 'src/app/service/smilers.service';
import { SmilersData, SmilersPicturesId } from 'src/app/model/smilers.model';
import { CustomToastService } from 'src/app/service/custom-toast.service';
import { SmilersCredentialsComponent } from 'src/app/components/smilers-credentials/smilers-credentials.component';
import { CustomLoadingService } from 'src/app/service/custom-loading.service';
import { toastTypeColor, toastTime } from '../../model/types';
import { UploadPhotoComponent } from 'src/app/components/edit-photo/upload-photo/upload-photo.component';
import { GalleryPhotoComponent } from 'src/app/components/views-photos/gallery-photo/gallery-photo.component';
import { SiteRCCService } from 'src/app/service/site-rcc.service';
import { HttpErrorResponse } from '@angular/common/http';
import { isWindows } from 'src/app/app.component';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-photos-list',
  templateUrl: './photos-list.page.html',
  styleUrls: ['./photos-list.page.scss'],
})
export class PhotosListPage implements OnInit {
  @ViewChild(GalleryPhotoComponent, { static: false }) galleryPhotoComponent: GalleryPhotoComponent;
  public radiusmiles = 1;
  public minmaxprice = {
    upper: 500,
    lower: 10
  };
  public isDesktop;

  public idUser;
  public newImage;         
  numPhotos
  user = {};
  public showAllPictures : number = 0;

  stlModalOpen   = false;
  stlViewerFileName: string | null = null;
  private stlObjectUrl: string | null = null;

  constructor(
    public alertController: AlertController,
    private activatedRoute: ActivatedRoute,
    private modalCtrl: ModalController,
    public platform: Platform,
    private userService: UserService,
    private objetService: ObjetService,
    private smilersService:SmilersService,
    // private navParams: NavParams,
    private navCtrl :NavController,
    private menu : MenuController,
    private camera : Camera,
    private route: ActivatedRoute,
    private router:Router,
    private context: Context,
    private customToastService: CustomToastService,
    private customLoading: CustomLoadingService,
    private siteRCCService: SiteRCCService,
    ) {

      console.log('Desktop',this.context.detectPlatformDesktop());
      console.log('Tablette',this.context.detectPlatformTablette());
      console.log('Android',this.context.detectPlatformAndroid());
      console.log('platforms',this.platform.platforms());


      this.isDesktop = this.context.isNotMobile() 
      // this.isDesktop = this.context.detectPlatformDesktop() || isWindows();
      
    this.route.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
        this.idPersonne = this.router.getCurrentNavigation().extras.state.idPersonne;
      }
    });
  }
  imagesToVisionate = [];
  selectedUser: any;
  platf;
  id = null;
  userImage = [];
  ListImageAdded = [];
  selectedImages = [];
  photoNumber: number;
  idPersonne: number;
  userSelected: string;
  ngOnInit() {
    
    this.idUser = localStorage.getItem("idPatient");
    this.idPersonne = this.idPersonne ? this.idPersonne : this.idUser;
    this.objetService.getPhotoNumber(this.idPersonne).subscribe(nb => {
      this.photoNumber = nb;
    });
    if( InjectedContext.picturePatient.length === 0)
    this.objetService.listphoto(this.idPersonne).subscribe(photos => {
      InjectedContext.picturePatient = photos;
    });
    this.getUserSelected();
    this.registerStlGlobals()
  }
  reloadUser;
  async createDossierPatient(path)
   {
     this.objetService.createDossierPatient(path).subscribe(value=>{
   },error=>{
     // alert(error);
    });
  }

      
  ionRefresh(event){
    
    
  setTimeout(() => {
    this.reloadUser=Math.random().toString(36);
    event.target.complete();
  }, 2000);
}

  closeModal() {
    this.modalCtrl.dismiss();
    this.navCtrl.navigateBack(['home']);
  }
testCamera()
{
  const options: CameraOptions = {
    quality: 100,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    sourceType: this.camera.PictureSourceType.CAMERA,
    allowEdit: false,
   // saveToPhotoAlbum : true
  }
  this.camera.getPicture(options).then((imageData) => {
   // imageData is either a base64 encoded string or a file URI
   // If it's base64 (DATA_URL):
   let base64Image = 'data:image/jpeg;base64,' + imageData;
   this.picturesThumbnail.set(imageData,imageData);
   InjectedContext.pictures = this.picturesThumbnail;
   InjectedContext.localPictures = this.picturesThumbnail;
   this.openPicture();
  //  this.createThumbnail(base64Image);
  }, (err) => {
   // Handle error
  });
}
async openPicture() {
  const modal = await this.modalCtrl.create({
    component: ImageViewerComponent,
    componentProps: {
   //   'newPictures': this.capturedImages,
      'idUser': this.idPersonne
    },
    cssClass: 'my-custom-modal-css'
  });
  modal.onDidDismiss()
    .then((data) => {
      //this.capturedImages.clear();
      this.capturedImage = "";
      this.picturesThumbnail.clear();
    });
  modal.present().then(value => {
  });

}
generateFromImage(img, MAX_WIDTH: number = 700, MAX_HEIGHT: number = 700, quality: number = 1, callback) {
  var canvas: any = document.createElement("canvas");
  var image = new Image();
  image.onload = ()=>{
    var width = image.width;
    var height = image.height;;

    if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
      }
    } else {
      if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
      }
    }
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, width, height);

    // IMPORTANT: 'jpeg' NOT 'jpg'
    var dataUrl = canvas.toDataURL('image/jpeg', quality);
    callback(dataUrl)
  }
  image.onerror = ()=>{
  }
    image.src = "data:image/jpeg;base64," + img;

}
createThumbnail(base64) {
  this.generateFromImage(base64, 700, 700, 1, data => {
    this.picturesThumbnail.set(base64,data);
    InjectedContext.localPictures = this.picturesThumbnail;
    this.capturedImage = data;
  }),error=>{
    alert(error);
  };
}
capturedImage = "";
picturesThumbnail =  new Map();
  detectPlatform() {
    this.platf = this.userService.detectPlatform();
    return this.platf;
  }
  selectionChanges(selectedImages) {
    this.selectedImages = selectedImages
  }
 
  setPhotoToVisionate(imagesToVisionate) {
    this.imagesToVisionate = imagesToVisionate
  }


  getUserSelected() {
    this.userService.getUserById(this.idPersonne)
      .subscribe((userObject) => {
        this.selectedUser = userObject;
      });
  }
  public noPhotos: string = 'Aucune photo selectionnée...';
  async visionneuse() {
    if(this.imagesToVisionate.length === 0 && !this.isDesktop) {
      await this.customToastService.presentToast(this.noPhotos, toastTypeColor.red, toastTime.long);
      return;
    }
    const imagesToVisionate = this.imagesToVisionate;
      if ( this.isDesktop){  
        this.router.navigate(['edit-photos-list'], 
      { state: { idPersonne: this.idPersonne ,
         userSelected :  this.userSelected,
         imagesToVisionate : this.imagesForListPhotoDesktop
        } , replaceUrl: true });
    }
     else{  
        this.router.navigate(['viewer'],
     { state: { idPersonne: this.idPersonne,imagesToVisionate: imagesToVisionate } });}
   
  }
  getPhotoNumber(photoNumber) {
    this.showPhotos = false;    
    this.photoNumber = photoNumber;
    this.getUserSelectedDetails(this.idPersonne);
  }

  getUserSelectedFromListePersonne($event) {
    this.userSelected = $event;
  }
  closeCameraOnBackButton() {
    var that = this;
    document.addEventListener("backbutton", function () {
      that.navCtrl.navigateBack(['home']);
    });
  }
  async takePicture() {
    this.customLoading.presentLoading().then(async value => {
    this.showAllPictures ++;
    this.router.navigate(['picturesPatient'],
    { state: { picturesPatient: this.userImage, showAllPictures: this.showAllPictures } }).then(x => {
     this.customLoading.dismissLoading();
   });
    });
  }
  async alertPicturesEmpty() {
    const alert = await this.alertController.create({
      header: 'Alert',
      subHeader: 'Subtitle',
      message: 'Aucun image trouvée.',
      buttons: [{
        text: 'OK',
        cssClass: 'secondary',
        handler: (blah) => {
          this.closeModal();
        }
      }
      ]
    });
    await alert.present();
  }
  ionPull(event)
  {

  }
  objets = {
    pkObjet: 0, nom: "", extension: "", id_patient: 0, vignette: "", width: 0,
    height: 0, taille: 0, estidentite: 0, dateCreation: "", echelle: 0, fichier: "", lastModif: "",
    repStockage: "", syncPath: "", dateInsertion: "", auteur: "", idGabarit: "",id_patient_orthalis:""
  };
  insertObjet(nom, extension, id_patient1, vignette, width,
    height, taille, estidentite, dateCreation, echelle, fichier, lastModif,
    repStockage, syncPath, dateInsertion, auteur, idGabarit , id_patient_orthalis) {

    this.objets["nom"] = nom;
    this.objets["extension"] = extension;
    this.objets["id_patient"] = id_patient1;
    this.objets["vignette"] = vignette;
    this.objets["width"] = width;
    this.objets["height"] = height;
    this.objets["taille"] = taille;
    this.objets["estidentite"] = estidentite;
    this.objets["dateCreation"] = dateCreation;
    this.objets["echelle"] = echelle;
    this.objets["fichier"] = fichier;
    this.objets["lastModif"] = lastModif;
    this.objets["repStockage"] = repStockage;
    this.objets["syncPath"] = syncPath;
    this.objets["dateInsertion"] = dateInsertion;
    this.objets["auteur"] = auteur;
    this.objets["idGabarit"] = idGabarit;
    this.objets["id_patient_orthalis"]= id_patient_orthalis ; 
    return  this.objetService.addObjet(this.objets)
        
  }
  file;
  base64textString;
  binaryString: string;
  name: string;
  imageData;
  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      header: 'alert!',
      message: ' <strong>image existe deja </strong>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });

    await alert.present();
  }
  imagesForListPhotoDesktop : objet[] =[];
  uploadedPhoto: boolean = false;
  async getuserImages(args : []){
    if (args.length != 0){
      this.imagesForListPhotoDesktop=args ; 
      this.uploadedPhoto = true; // for displaying toolbar
      this.getAllPictures(); // get all images of user
    }
    
   // this.userImage.concat(args)
  }
   nbImageUpLoad : number = 0; 
  async onFileSelected(event) {
      if(event.target.files.lenght==0) return
    const modal = await this.modalCtrl.create({
      component: UploadPhotoComponent,
      cssClass : ' sc-ion-modal-md-h-progressBar ' ,
      componentProps: {
        'fileList': event.target.files,
        'idUser' : this.idUser ,
        'ContextFolder' : Context.folder  
      },
      keyboardClose :false,
    });
    modal.onDidDismiss().then((result)=>{
      let imgs = result.data;
      if(imgs) {
        this.ListImageAdded=[];
        this.ListImageAdded.push(result.data) ; 
        this.ListImageAdded = this.ListImageAdded.slice(); 
        this.galleryPhotoComponent.refreshImage(imgs);
      }
    })
    modal.present();
  }
  public userDetails;
  public showPhotos =false;
  public photoSmilers = [];
  async getUserSelectedDetails(id) {
    this.userService.getUserById(id).subscribe(res => {
      this.userDetails = res;
    });
  }
  async getAllPictures() {
    // loading photos
    if (this.imagesForListPhotoDesktop.length == this.photoNumber) {
      let imgFiltred = this.imagesForListPhotoDesktop.filter(pic => !pic.fichier.includes('PDF'));
      await this.findAllPictures(imgFiltred).then(async res => {
        this.photoSmilers = res;
        let i = 0;
        while (i < this.photoSmilers.length && !this.showPhotos) {
          if (this.photoSmilers[i]) this.showPhotos = true; // when one image valid show btn smilers
          i++;
        }
        if(i == this.photoSmilers.length) this.showPhotos = true; // no photos to display
      })
    }
  }
  async findAllPictures(imgFiltred) {
    let photos = [];
    let frontalViewSmile = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.frontalViewSmile);
    let profile = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.profile);
    let occlusionViewFront = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.occlusionViewLeft);
    let occlusionViewLeft = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.occlusionViewLeft);
    let occlusionViewRight = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.occlusionViewRight);
    let occlusionViewMaxilla = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.occlusionViewMaxilla);
    let occlusionViewMandibula = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.occlusionViewMandibula);
    let panoramic = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.panoramic);
    let innocclusion = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.innocclusion);
    let teleRadio = await imgFiltred.find( p => p .idGabarit == SmilersPicturesId.teleRadio);
    await photos.push(frontalViewSmile,profile,occlusionViewFront,occlusionViewLeft,
      occlusionViewRight,occlusionViewMaxilla,occlusionViewMandibula,panoramic,
      innocclusion,teleRadio);
      return photos;
  }
  makePicturesToSend(photos) {
    let allPics = [];
    for(let i = 0 ; i < photos.length ; i++) {
      let pic;
      if(photos[i]) {
         pic = [Context.root_folder + Context.folder + this.idPersonne + "/" + photos[i].fichier, 
        photos[i].fichier.toLowerCase()];
      } else pic =null
      allPics.push(pic);
    }
    return allPics;
  }
  async smilersCredentials() {
          const modal = await this.modalCtrl.create({
        component: SmilersCredentialsComponent,
        componentProps: {
          'photos': this.photoSmilers,
          'userDetails': this.userDetails
        }
      });
      modal.onDidDismiss()
      .then((data) => {
        if(data['data']) {
          this.smilersData(data['data']);
        }
      });
      return modal.present();
  }
  async smilersData(userFromModal) {  
   let date = userFromModal.naissance.substring(0,10);
   let dateToSend = date.substring(date.length - 2,date.length) + "/" + date.substring(5,7) + "/" 
      + date.substring(0,4);
   let allPics = this.makePicturesToSend(this.photoSmilers);
   let smilersPics:SmilersData = new SmilersData();
      smilersPics.prenom = userFromModal.prenom;
      smilersPics.nom = userFromModal.nom;
      smilersPics.titre = userFromModal.titre;
      smilersPics.dateNaissance = dateToSend;
      smilersPics.PIC1 =  allPics[0];      
      smilersPics.PIC2= allPics[1];
      smilersPics.PIC3= allPics[2];
      smilersPics.PIC4= allPics[3];
      smilersPics.PIC5= allPics[4];
      smilersPics.PIC6= allPics[5];
      smilersPics.PIC7= allPics[6];
      smilersPics.PIC8= allPics[7];
      smilersPics.PIC9= allPics[8];
      smilersPics.PIC10= allPics[9];
    await this.customToastService.presentToast("  La création du patient dans Smilers est en cours  ... ", "primary", 4000);
    await this.smilersService.addPatientToSmilers(this.idPersonne,smilersPics).toPromise().then(t => {
      window.open("https://smilers.biotech-dental.com/fr/treatment/cart");
    })
  }

  siteRCC() {
    if(this.selectedUser.idRcc) {
      window.open(`${this.siteRCCService.getSiteUrl()}/${this.selectedUser.idRcc}`);
    }
    else {
      this.customLoading.presentLoading().then(e => {
        this.siteRCCService.addPatient({id: this.selectedUser.id_personne, cabinet: "basdiag"}).subscribe(
          (value: any) => {
            this.selectedUser.idRcc = value.id;
            window.open(`${this.siteRCCService.getSiteUrl()}/${value.id}`);
          },
          (error: HttpErrorResponse) => console.error(error),
          () => this.customLoading.dismissLoading()
        )
      });
    }
  }

  smilersOpen() {
    window.open("https://smilers.biotech-dental.com/fr/connexion");
  }

  async savePDTLink(link: string) {
    const destName = "link_" + link + ".pdt" ;
    
    // Définir une vignette statique pour les fichiers STL
    const staticVignette = "iVBORw0KGgoAAAANSUhEUgAAAd4AAAISCAYAAABiXK6RAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAJEZJREFUeJzt3XuUnHd93/GQOzlN0kuSk9P2NG3CaZpD0jRpT5pACS0nF0gaWiBJ05DQJECCm4QGkqbkpElNINwxF3MzxraklWQjYwwYfMdg42CDYxuDAWOBZVm7c1tpJVl3ydJ0Hilijby7mnn22fl+n+d5vTmv/4x2NL+Z+Wh2d2a+7uskSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSVKytm7d+i3dbr83MgTaZ+PMxmMzG2aGye3buH7jM6IfL6VK6nYHvx19xwfi1GR4C8dmZmZeEP2YKa260R3v9ug7PhCnRsNbODGzfubc6MdNqXS9Xu+Ho+/0QKyaDe9p7/nYxz72jdGPodLEje50b4y+0wOxajq8hSu3bNny+OjHUWnshsPh40Z3uu3Rd3ogVo2Hdzizfua2zZs3f1f046k0Vv1+/6ei7/BAvFoP7ylbZ2ZmnhD9mCqdtdEd7nXRd3ggXgOGt9Adje+PRz+uSivW7fb+NvoOD8RryPAW9o3G9+nRj63Ski0sLHzn6A73SPQdHojXoOEtHNuwYcPzox9jpcfU6/WeGX1nB3Jo2PAWvNZX+er1+udF39mBHBo4vKesn7nQa32VptGd7a7oOzuQQ2OH9xSv9VV8u3bt+o7Rne149J0dyKHhw+u1voqv3+8/KfqODuTR+OE95QubNm36vujHX7W0Tqf/e9F3dCCPlgxvwWt9FVOn03tL9B0dyKNFw1vwWl9Nv2538KHoOzqQR8uGt3Bk4/qNvxH9WKwWNbqj3RN9RwfyaOHwFrzWV9Or1+vvjr6jA3m0dHhPWT9z/rnnnvv10Y/LanDD4fCbRne0E9F3dCCPVg/vKV7rq7VrMBh8b/SdHMjF8M54ra/Wrk6n80PRd3IgF8P7VV7rq+qbmxv8WPSdHMjF8D7K+pm5mZmZH41+rFaD6vV6Pxl9Jwdy2bx58/7wwcvFa31VXZ3O4CnRd3Igly1bLu8nGLtsjozG97nRj9lqQN3u/FOj7+RALu+/4soHEwxdRl7rq9VneIEzXXftdZ9JMHJ5ea2vVpPhBc5029/c/onwccvPa31VLsMLnOnzn//CLQmGLT+v9VWZDC9wpoce2nFP+KjVx+fXr1//z6Ify1WjDC+whCObN20+lGDU6qIzGt8fi348V00yvMBSrr/++rsTDFqdeK2vxsvwAkvxc95SjmzcsPHXox/XlTzDCyyl0+nNb9q4yVtHTs5rfbVyhhdYzo033vi3CYasnrzWV8tleIHlPPjg9jvDB6zevNZXj83wAiv58FUf/mKCAauzj1900UXfHv1Yr0QZXmAlDzyw/VMJxqvWNm7Y+MnRM9/vjH68V5IML3A23ru5AjMzt15yySXfGv2YrwQZXuBs5ua6D27auOlo+HjV3OiZ7xa/cCXDC4zlnns+e3P0cDXBaHz/PPpxX8EZXmBMx6+/9vq7ooerAY5tXLfxydGP/QrM8ALj6nR6/S3v3TJIMF5198AFF1zwbdGP/wrK8AKTmJ3t3H/p5sv2JBivWtuwYcMrox//FZThBSb10EOzn9m0cdOR6PGquSObNm36/ugNUECGFyhj+/bZuy699NJ9CQasvtbPXBy9AQrI8AJlzc7OffG9l713V/iA1dexdevW/UD0DmjKGV5gdXpzV3/kms8mGLF6Wj/z+ugd0JQzvEAFjt5xx503b5zZeDx8yOpn3jtatSzDC1Rldnbuvo9c9ZH7EoxZrWxcv/FZ0VugKWZ4gYo9ct9993/iiiuu2BE9aLUxM7Muegs0xQwvsEaObd365Vs/+IGrvhQ+bPnNew/nFmV4gbU2O9v50p133vXxK6+4cnuCkUtp3bp1T4zeA00pwwtM09xcb+7++7/8idtv/9TN11577V2XX375XPToZbBhw4bnR++BppThBTLo9fq7i1Gem+s+1EY7HprzsqK2ZHgBUrg6eg80pQwvQAr3Re+BppThBUhhV/QeaEoZXoAUDkfvgaaU4QXIYdQ3Rm+CppDhBcjh3nvv/eboTdAUMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvC3J8ALkYHhbkuEFyMHwtiTDC5CD4W1JhhcgB8PbkgwvQA6GtyUZXoAcDG9LMrwAORjelmR4AXIwvFPsydtf/tKn7Ph/QwDa65eu6nxb9B41uugDBiCf6G1qXNEHCkBu0TvVmKIPEoB6iN6r+jccPi76EAGoj+jZqnXRhwdA/URvV22LPjgA6il6v2pZ9KEBUF/RG1a7og8MgHqL3rFaFX1YANRf9JbVpuiDAqAZovesHnnJEAAViZ60WhR9SAA0R/SmpS/6gABoluhdS1/0AQHQLNG7lrrowwGgeaK3LXXRhwNA80RvW+qiDweA5onetrRFHwwAzRS9b2mLPhgAmil639IWfTAANFP0vqXsyQ/+1e9EHwwAzRS9cSmLPhQAmit641IWfSgANFf0xqUs+lAAaK7ojUtZ9KEA0FzRG5ey6EMBoLmiNy5l0YcCQHNFb1zKog8FgOaK3riURR8KAM0VvXEpiz4UAJoreuNSFn0oADRX9MalLPpQAGiu6I1LWfShANBc0RuXsuhDAaC5ojcuZdGHAkBzRW9cyqIPBYDmit64lEUfCgDNFb1xKYs+FACaK3rjUhZ9KAA0V/TGpSz6UABoruiNS1n0oQDQXNEbl7LoQwGguaI3LmXRhwJAc0VvXMqiDwWA5oreuJRFHwoAzRW9cSmLPhQAmit641IWfSgANFf0xqUs+lAAaK7ojUtZ9KEA0FzRG5ey6EMBoLmiNy5l0YcCQHNFb1zKog+Flf1u/93Di/d+LIV37blh+LqFDw3/fOdlwz8cXDJ8Xu/tw//Sef3UrovndM4Lvw6W8tbd1wz/Yud7h7/Xv3D4rM4bwm8zS/mDwcXh11OE3x/9vaOv+7aL3riURR8KK3vT7o8M69DcsYXhrYfuG848fMvw5bved3KUq74uzum/J/qvOXad0fVx9+Ftw2sOfObkABT/WPmV7pvCbkfr994cfZWEVPy9o+/DbRe9cSmLPhRWttIz3vuOzFX6ILX/+KGv+fOv2Pep4U0H7x1+7shDpf68QyeODm89eN/wjbs/PPzFudeu+rp4dueNy14XNxz4bKXXRdGV+z79mK9TPJB/ZP9dw08d2jrc+cjDE/+Z+0bX8W2H7h++auHK4c/Pvmpqt6PLHv7kqq+P4vYxe2zX8N4jO07+o2Lv8QOr/jMf3YETh0/+uacV/3hZbZc9/Dfh9+G2i964lEUfCuV9cP/fVvBwt1j3kd0rfr0XjZ5xfnEVY3/t6Nnfb/XesSbXxf+Z31ThNXGqcZ61/3LnvOFf7twyfN++20sNxS0Hv3jy2fDa31buKHUd7D6+f3jR3ptG/3B6zWP+zE+MLnuVffHI7GO+xi+Mvu7rF64a3nN4e6k/8wOjv3f0/bTtojcuZdGHQnnTHt7TLh09i1hNnzz0pdGIX1jpdbEWw/s/Svwj4Y8G64d3HPryxF+rePZ4+b7bhr/efeua3FaKf/RM2vm7r13xz6x6eL+wxPA+2p/Mz5x8VjxJxbf6o++nbRe9cSmLPhTK+1DQ8BaKkVhNJ0b/K76V/bOzf13JdbEWw7uaZ+cv27l5NKYHS33dLaPrtupvQ9988Atjf/0Hjw6Gz+2ef9Y/cxrPeM/030f/MJmb4DsLHz/4+fD7adtFb1zKog+F8iKHt1DFz+C2H5uv5DejszzjfbTiZ9L3H+2W+trFM+Dil9Squq0UP5Mep+I8xv3HUMTwFopve99/tDPWn1n8PD36ftp20RuXsuhDobzo4X39wocq+bqDR/ae/Fnpaq6LbM94TytGohizsl29/+7REL5y1ZfjnsMPnvVrHTxxZPjfum8e+8+MGt7CM+ZeffLnz2er+CWt6Ptp20VvXMqiD4Xyon7G+2hHThyr5GsXzwx/ZhUDk/EZ72nFy4hW00PHdp78FutqLsM4vwFffHt8kj9z2j/jPVNxeav+M6le9MalLPpQKC/D8N55+IHKvn7x8p2y10XWZ7ynXbj3o6u6LAujZ3er+YfA2Z51Fy/HmvTPjHzGe9qNBz634p/5wNF++P207aI3LmXRh0J50d9qLhSvba2q4heufrv3zlLXReZnvKf1H9mzqstTvAb4hf13l/ravRW+dvEt5qVeLnQ2GYb3mXOvW/G7Lt1jk9+mqVb0xqUs+lAoL8Mz3j/beWmll+GOw18pdV1kf8ZbeM3CB1Z9mR4+frDUO2Ct9PPQ83Z/pNTfJ/pbzaet2/vxZf/MXY/sC7+ftl30xqUs+lAoL8Mz3hf2L6j0MhSVeaZZh2e8hTLvdnVmxct9nj432cuNDp84uuSfVfxi20/vOLfU3yXDM95C8YtWy/39imfz0ffTtoveuJRFHwrlZXjGW3yrr+qKf1BMejnqMrzv3bf6t24s+uiBz030dZfrbXuuK/13yfKMt3DZCm/qEn0/bbvojUtZ9KFQXoZnvIWqK56FTXoZ6jK8xXtvV9WLB+vG+prF63KXqniW+HOreAOTLM94C8UnVxW/I7BUT5t9Rfh9tc2iNy5l0YdCeRme8RbKvkPTSv3qBK8nLdThZ7yF4tu6k77t4XIVv6n81DG+TfxLy3xXonj3sdX8XTINb6F4s4ylKvOLY1QneuNSFn0olJflGW/xDLXqil/amuQy1OUZb2G5gSjTGxauOuvXK96cZKkmebOMpWT6VnOheC/npSreQSz6vtpm0RuXsuhDobwsw7uad2Zarkl/9lin4X33nhsru4zFx/Sd7ev9Zu9tj/n/FZ/2s9q/R7ZnvIWlXja1Vh88wXiiNy5l0YdCeVmGt+rPBS56/4RvplGXbzUX/rTiy3q2jxV8wRK/ef7qhQ+s+u+R7Rlv4YIl/lFT9rXhVCN641IWfSiUl2V4V/MZvcs16afK1Gl4f6WzureQPLPPHH5wxa/3B4OLv+a/L95woor3f874jLf4tvKZndN/T/h9tc2iNy5l0YdCeU0e3knf3L5Ow1soXl9aVcVv8670CU//e37j1/z31x24p5K/Q8bhLXz+yI6v+XNfMr8h/L7aZtEbl7LoQ6G8PMM7W+nlKNp6tDvRZajb8H7laK/Sy/qmFd59qvhW9KN7yWB9JX+HjN9qLrx599Vf8+e+bH6yD3+gWtEbl7LoQ6G8PMNb/TPeSR+E6za8Vf5mc9FK3yF45a73f/W/K95ycpyXII0j6zPe4k1djo/+d7oqP9eYyUVvXMqiD4Xymjy8k75nc92G96r9d1Z6WY8PTwz/446XL/m1ipccne79+z5V2d8h6zPewqP/YVPFL5JRXvTGpSz6UCgvyxtofLnib5sWNfmXqwqXrPDG/mV70TK/RPS2Pdd+9b/5/cHFlf0dsj7jLfzlzi1f/XOLbz1H31fbLHrjUhZ9KJSX5RnvjmM7K70cRZsevnWiy1C34X30GFbVW5YZmNOfBVz1J/VkHt7i2X/xMYpF79pzQ/h9tc2iNy5l0YdCeVmGd6XPei3bK3ZdMdFlqNvwvm7hQ5Vf3uV+W/k1Cx88+TPg83dfW+nfIfO3mgvF4BZ/71ctXBl+X22z6I1LWfShUF6WbzUXz6Sqrni3pUkuQ92G99xdl1d+eYs3Mpnm7S/zM17yiN64lEUfCuVleca73KfClG3P8QMTX4Y6vWVk4czX1lbRwvH9U739GV7GEb1xKYs+FMrLMLz/tfOGSi9D0Yf33zXx5ajbM94XDy6p/PIW/UwF70g1LsPLOKI3LmXRh0J5Gb7VvNT7AK+2Mu80VLfhrfJzeR/dc7vnT+32Z3gZR/TGpSz6UCgvwzPeM98VabXdf7RT6rqo27ean9d7e+WXt+gPR8+kp3X7M7yMI3rjUhZ9KJSXYXhnHr6l0stQ/OyzzHVRt2e8v9Z9S+WXt+hsn1RUJcPLOKI3LmXRh0J5GYb3zsMPVPb1bzjw2dLXRd2e8a7Fz8aL/nrX9F46Y3gZR/TGpSz6UCgvw894q/qUneK1wE+fe1Xp66Juz3iLTxNai6p+re5KDC/jiN64lEUfCuVFP+P9i53vreTrHj5x9OTPPFdzXRjeUxVvRTmt25/hZRzRG5ey6EOhvOjhLT6AvYpetnP1H9tmeE+1fu/NU7v9GV7GEb1xKYs+FMqL/FbzHw3Wr/rrDR7ZO3x+712VXBeG91Tv3nPj1G5/hpdxRG9cyqIPhfKinvH+4txrhnuPH1jV17r10H3Dp8+9urLrwvCe6i27r5na7c/wMo7ojUtZ9KFQXsQz3mIwVvP5u7PHdq3Jm9b7reZTvXbhg1O7/RlexhG9cSmLPhTKm/bwFj+L3VPyme7NB78w/OP5mTW7Lur2jPc5nfMqv7xFL9/1vqnd/gwv44jeuJRFHwrlVT28xacMFe8hXHjp/IaTrwl9x57rh1fvv3u4//jhif+8Ow5/5eTLW/7z3GvX/Lqo2zPeX+2+ufLLW/Qna/iPmzMZXsYRvXEpiz4Uyqt6eFfbZ49sH67b+/HRcK+b+nVRt2e8xXsqr0WTfpziahhexhG9cSmLPhTKW4vhLT44fCW3Hbr/5AeuX77vtpMfNF68ReE0H+yXU7fhXav3av5Zn05EMtEbl7LoQ6G86NfxZlK34X1R/8LKL+9un8dLQtEbl7LoQ6E8w7uobsNbfPRh1U17uAwv44jeuJRFHwrlGd5Fdfvlqqo/TrHomgN3T/U6N7yMI3rjUhZ9KJRneBfV7Rnvqxc+UPnlfd3Ch6Z6nRtexhG9cSmLPhTKM7yL6ja8F+y5sfLLW/ym9DSvc8PLOKI3LmXRh0J5hndR3Yb3fftur/Sy7j1+cOrXueFlHNEbl7LoQ6E8w7uobsN708F7K72sxZ837evc8DKO6I1LWfShUJ7hXVS34V3N+10v1V/u3DL169zwMo7ojUtZ9KFQnuFdVLfhPXjiSGWXs/iznjb7iqlf54aXcURvXMqiD4XyDO+iOg3vMyv+SMDincQirnPDyziiNy5l0YdCeYZ3UZ1ex1t8CEWVvWSwPuQ6N7yMI3rjUhZ9KJRneBfV6Rlv8R7XVXX/0U7YdW54GUf0xqUs+lAoz/AuqtPwFp9NXFXF3zvqOje8jCN641IWfSiUZ3gX1elbzXuOH6jk8t13ZC70Oje8jCN641IWfSiUZ3gX1eUZ7wv7F1Ry2Y4PTwx/p/eu0Ovc8DKO6I1LWfShUJ7hXVSX4b1o702VXLb1e28Ov84NL+OI3riURR8K5RneRXUZ3rljC6u+XF852hs+dcfLw69zw8s4ojcuZdGHQnmGd1EdhvelFXwGb/Hz4V/unBd+fRcML+OI3riURR8K5RneRXX45arbDt2/qstz5MSx4Qv6F4Rf16cZXsYRvXEpiz4UyjO8i7IPbxW/VBX50qGlGF7GEb1xKYs+FMozvIuyf6v5zsMPlL4cxUf+/f7g4vDr+EyGl3FEb1zKog+F8gzvoszD+5bd15S+DNuPzQ+f3Xlj+PW7FMPLOKI3LmXRh0J5hndR1m81v3iwrvTX37LvtuHPzL4y/LpdjuFlHNEbl7LoQ6E8w7so4/D+z/5Fw0Mnjk78dWeP7Rq+qP+e8Ov0bAwv44jeuJRFHwrlGd5F2b7V/Nbd1wyPnXhkoq9XvFTobXuuHT5t9q/Cr89xGF7GEb1xKYs+FMozvIuyPOMtXu7z2SPbJ/o6B04cHl6y9+PDn5v96/DrcRKGl3FEb1zKog+F8gzvouhnvL/Ze9vJTx06MfrfuBXvQPX6hatS/xx3JYaXcURvXMqiD4XyDO+itRje5/Xe/piv82vdt5x8ac+5uy4fvm3PdcOr9989fPDoYOw/83NHHjr5PsvnJP8Z7nO75w9fPLhkRZM+sz9bxW9wn+1rrtUnRrF2ojcuZdGHwsrevPvqSh/c1qJpXRfFLxzVqYeO7RzedPDe4YV7Pzr84/mZWn0r+cP774q++pbs9kNbw68bJhO9cSmLPhRWZngXnZNoePcfPzzcNnqm+6nREFy1/86T4/qqhSuH/2uw7uSz4ujbzWoZXqoSvXEpiz4UAJoreuNSFn0oADRX9MalLPpQAGiu6I1LWfShANBc0RuXsuhDAaC5ojcuZdGHAkBzRW9cyqIPBYDmit64lEUfCgDNFb1xKYs+FACaK3rjUhZ9KAA0V/TGpSz6UABoruiNS1n0oQDQXNEbl7LoQwGguaI3LmXRhwJAc0VvXMqiDwWA5oreuJRFHwoAzRW9cSmLPhQAmit641IWfSgANFf0xqUs+lAAaK7ojUtZ9KEA0FzRG5ey6EMBoLmiNy5l0YcCQHNFb1zKog8FgOaK3riURR8KAM0VvXEpiz4UAJoreuNSFn0oADRX9MalLPpQAGiu6I1LWfShANBc0RuXsuhDAaC5ojcuZdGHAkBzRW9cyqIPBYDmit64lEUfCgDNFb1xKYs+FACaK3rjUhZ9KAA0V/TGpSz6UABoruiNS1n0oQDQXNEbl7LoQwGguaI3LmXRhwJAc0VvXMqiDwWA5oreuJRFHwoAzRW9cSmLPhQAmit641IWfSgANFf0xqUs+lAAaK7ojUtZ9KEA0FzRG5ey6EMBoLmiNy5l0YcCQHNFb1zKog8FgOaK3riURR8KAM0VvXEpiz4UAJoreuNSFn0oADRX9MalLPpQAGiu6I1LWfShANBc0RuXsuhDAaC5ojcuZdGHAkBzRW9cyqIPBYDmit64lEUfCgDNFb1xKYs+FACaK3rjUhZ9KAA0V/TGpSz6UABoruiNS1n0oQDQXNEbl7LoQ1kL/+am6+5rux/e2P0kUB8/unHuln+3ee6GDJ502dwtVXju1Vu/I3rjUlbl4P345960+wnvfP2Op6x/4TBSt9sHINiuXbsM71Ktdmx/+PZ3zUUPreEFyMfwLlPZwX38eTfcFj2whhcgL8O7TJMO7r/6xEXbo4fV8ALkZ3iXaaLhTTCqhhegHgzvMjVtdA0vQA6Gd5nONrj/8qZLtkUPqeEFqB/Du0wrje73bL7q7ugRNbwA9WR4l6nOv0RleAHyMrzL1ISf6RpegHwM7zI1bXQNL0AOhneZmja6hhcgB8O7TI8e3Sdve8Wx6NE0vADNYHiXqWnPdg0vQA6Gd5lOj+6PfPodvejBNLwAzWF4l6lpz3YNL0AOhneZDC8Aa8HwLlMxuj/4rlc15tvMhhcgB8O7TE17tmt4AXIwvMtkeAFYC4Z3mX7g4rffGz2UhhegeQzvMj1p3TmNeNMMwwuQi+FdpuiRNLwAzWR4lyl6JA0vQDMZ3qUaDh8XPZKGF6CZDO8SRQ+k4QVoLsO7RE+65JynRY+k4QVoJsO7TNEjaXgBmsnwLlP0SBpegGYyvMsUPZKGF6CZDO8yRY+k4QVoJsO7TNEjaXgBmsnwLlP0SBpegGYyvCsUPZSGF6B5DO8KRQ+l4QVoHsO7QtFDaXgBmsfwnqXosTS8AM1ieM9S9FgaXoBmMbxjFD2YhhegOQzvGEUPpuEFaA7DO2bRo2l4AZrB8E5Q9HAaXoD6M7wTFD2chheg/gzvhEWPp+EFqDfDW6LoATW8APVleEsWPaKGF6CeDO8qGo3Z7ugxNbwA9WJ4Kyh6UA0vQH0Y3oqKHlXDC1APhrfiosfV8ALkZnjXqi1bviF6aA0vQD6Gd0pFj67hBcjB8LakXq/376NvbAAY3tZkeAFyMLwtyfAC5GB4W5LhBcjB8LYkwwuQg+FtSYYXIAfD25IML0AOhrclGV6AHAxvSzK8ADkY3pZkeAFyMLwtyfAC5GB4W5LhBcjB8LYkwwuQg+FtSYYXIAfD25IML0AOhrclGV6AHAxvSzK8ADkY3pZkeAFyMLwtyfAC5GB4W5LhBcjB8LYkwwuQg+FtSYYXIAfD25IML0AOhrclGV6AHAxvSzK8ADkY3pZkeAFyMLwtyfAC5GB4W5LhBcjB8LYkwwuQg+FtSYYXIAfD25IML0AOhrcldbvdn4i+sQFgeFtTv9//19E3NgD6w1HfGL0JmkK9Xu9fRN/YAOgfjN4DTalut/vdCW5wAG3Xj94DTalt27Z9a4IbHEDbfTl6DzTFRgd+NMGNDqC1Op3+Z6K3QFNsdOjbom90AO02uCp6CzTFer3+dfE3OoBWe2P0FmiKdbu98xPc6ABaq9Ppvyh6CzTFer3Bi6NvdABt1uv1nha9BZpio39p/Xz0jQ6gzXbs2PlPordAU+zvXst7IvqGB9BSxdtWPS56CzTlRgf/uQQ3PoAWGlwavQEKqNvtvTX+xgfQPp1O//eiN0ABjQ7+OdE3PoA2mpub/8HoDVBAs7Oz/2h0AzgefQMEaJlO9OO/AhvdAG5JcCMEaJN3RD/2K7Di5wwJboQArTE3139y9GO/Atu+fc8/GN0QDkffEAFa4kEvI1Lxvs3vT3BjBGi8Xm/wyujHfCWo0+k/O/rGCNAGnU7nh6If85Wg4XD4DaMbxNboGyRAw10T/XivRBWfkpHgRgnQWJ3O4KejH+uVqK1bt37L6IYxF33DBGio26If55Ww0Q3jTxPcOAEaaP4Xox/jlbBdu3Z9x+gG0ou/gQI0yeDTXkKkZRvdQH4r/kYK0BjHe73eT0Y/titxxb/KRjeUmxPcWAFqr9MZXBj9uK4aNPrX2Y+MbjDHom+wADW30O12vzv6MV01yWf1AqzaOdGP5apR27Zt+9bRjeaeBDdcgDq62i9UaeK63e4TRzeeAwluwAC10ev1ZzudzndFP4arpvV6vRdE34gBaqT4LeanRT92q+Z1Ov3NCW7MAOl1Or3/G/2YrQa0Y8eOx49uULdE36ABMhs9Sdk0HA6/PvoxWw1pYWHhO0c3qs9E37ABkrrx3nvv/ebox2o1rPn5+X88unE9mOAGDpBI747BYPD3oh+j1dCKD3Ee3dAG8Td0gAx6X/QmGVrzer3e949ucFvjb/AAkQafNrqaWoPB4Ht7vf7d8Td8gOnrdPo3zM/Pf3v0Y7FaVvEzjdGN7/roOwDANI2edMwMh8Nvin4MVkv7u7eWfGf0HQFgCo71eoM/81aQStHome+zuic/iSP8jgGwBnoPdTqD/xD9WCt9TZ1O5/tGN9BPxt9BACr1wR07dvzD6MdYacmKF5CPbqR/MXIwwZ0FYDXme73e831rWbVodnbXPx3daDckuOMATOp49+Tjl5cKqYZ1u4NnjG7AX0pwRwI4q06n/zdzc/M/Hv3YKa2q4k3De73eLxVvqxZ9pwJYSq/Xv7V4nPJtZTWu4rcCixeeR9/JAEZOdLuDq/r9/k9FPzZKa163233i6EZ/7sgDCe58QKsU76/cP3cwGDwh+rFQmnrFt6FHI/yfRneEi0Z3hE78HRJoqK29Xv+8Tmf+30Y/7kmp+rsPYHje6A5yQfGC9QR3VqCein/Ib+l0er87+sf9P49+bJNq02iIv6fTGTyleC3d6E702tEgv7976k067hn5ysiukSMJ7uTAdBTvEVB8NGlx/79r5JZud3BZrzd4RafT/43RyP7Etm27/370Y5ckSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZK05v1/q6/nAcCfD8gAAAAASUVORK5CYII="; // Remplace par ton URL

    try {
      // Création de l'objet avec la vignette statique
      // const base64Vignette = await this.getBase64FromUrl(staticVignette);
      await this.insertObjet(
        destName,               // Nom du fichier
        ".pdt",                 // Extension
        +localStorage.getItem('idPatient'), 
        staticVignette,         // Vignette statique
        141, 200, 0, 0, null, 1, 
        destName, "", 
        "", 
        "", "", "", 0, localStorage.getItem('idPatient')
      ).toPromise().then(res => {
        if (res !== null) {
          let imgs = [res];
          if(imgs) {
            console.log("imgs",imgs);
            this.ListImageAdded=[];
            this.ListImageAdded.push(res) ; 
            this.ListImageAdded = this.ListImageAdded.slice(); 
            console.log('ListImageAdded',this.ListImageAdded);
            this.galleryPhotoComponent.refreshImage(imgs);
            // this.galleryPhotoComponent.addNewPhotos(imgs);
            
          }
        }
      });

    } catch (error) {
      console.error('Erreur lors de l\'upload du fichier:', error);
    }
  }

  async PDT() {
    const alert = await this.alertController.create({
      header: 'Ajouter un lien',
      inputs: [
        {
          name: 'link',
          type: 'url',
          placeholder: 'https://example.com',
        },
      ],
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
        },
        {
          text: 'Enregistrer',
          handler: async (data) => {
            const link = data.link;
            if (link) {
              console.log('Link saved:', link);
              await this.savePDTLink(link);
            }
          },
        },
      ],
    });

    await alert.present();
  }

  openStlViewer(fileOrUrl: File | string) {
    if (typeof fileOrUrl === 'string') {
      this.stlObjectUrl = fileOrUrl;
      this.stlViewerFileName = fileOrUrl.split('/').pop() || '3D Model';
    } else {
      this.stlObjectUrl = URL.createObjectURL(fileOrUrl);
      this.stlViewerFileName = fileOrUrl.name;
    }
    this.stlModalOpen = true;
  }

  closeStlModal() {
    this.stlModalOpen = false;
  }

  onStlModalDismiss() {
    if (this.stlObjectUrl && this.stlObjectUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.stlObjectUrl);
    }
    this.stlObjectUrl      = null;
    this.stlViewerFileName = null;

    const renderer = (window as any).stlRenderer;
    if (renderer) {
      renderer.dispose();
      (window as any).stlRenderer = null;
    }
  }

  initializeStlViewer() {
    if (!this.stlObjectUrl) return;

    this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js')
      .then(() => this.loadScript(
        'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/STLLoader.js'))
      .then(() => this.loadScript(
        'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/controls/OrbitControls.js'))
      .then(() => this.setupStlViewer());
  }

  private loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) { resolve(); return; }
      const s = document.createElement('script');
      s.src     = src;
      s.onload  = () => resolve();
      s.onerror = () => reject(new Error(`Failed to load: ${src}`));
      document.head.appendChild(s);
    });
  }

  private setupStlViewer() {
    const container = document.getElementById('stl-viewer-container');
    const loading   = document.getElementById('stl-loading');
    const controls  = document.getElementById('stl-controls');
    if (!container || !this.stlObjectUrl) return;

    const old = container.querySelector('canvas');
    if (old) old.remove();

    const THREE = (window as any).THREE;

    const scene    = new THREE.Scene();
    scene.background = new THREE.Color(0xf0f0f0);

    const camera = new THREE.PerspectiveCamera(
      75, container.clientWidth / container.clientHeight, 0.1, 1000);
    camera.position.set(50, 50, 50);

    const canvas = document.createElement('canvas');
    canvas.style.cssText = 'width:100%;height:100%;display:block;';
    container.appendChild(canvas);

    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
    renderer.setSize(container.clientWidth, container.clientHeight);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type    = THREE.PCFSoftShadowMap;

    const orbit = new THREE.OrbitControls(camera, renderer.domElement);
    Object.assign(orbit, {
      enableDamping: true, dampingFactor: 0.1,
      enableZoom: true, enableRotate: true, enablePan: true,
      minDistance: 5, maxDistance: 200,
      minPolarAngle: 0, maxPolarAngle: Math.PI,
    });

    scene.add(new THREE.AmbientLight(0x404040, 0.4));
    const dir = new THREE.DirectionalLight(0xffffff, 1.0);
    dir.position.set(20, 20, 10);
    dir.castShadow = true;
    scene.add(dir);
    const fill = new THREE.DirectionalLight(0x5a91cd, 0.3);
    fill.position.set(-10, 5, -5);
    scene.add(fill);
    const rim = new THREE.DirectionalLight(0xffffff, 0.2);
    rim.position.set(0, 0, -20);
    scene.add(rim);

    const axes = new THREE.AxesHelper(20);
    scene.add(axes);

    (window as any).stlScene    = scene;
    (window as any).stlCamera   = camera;
    (window as any).stlRenderer = renderer;
    (window as any).stlControls = orbit;
    (window as any).stlModel    = null;
    (window as any).stlAxesHelper = axes;

    const loader = new THREE.STLLoader();
    loader.load(
      this.stlObjectUrl,
      (geometry: any) => {
        const material = new THREE.MeshPhongMaterial({
          color: 0x5a91cd, shininess: 150, specular: 0x222222,
          side: THREE.DoubleSide,
        });
        const model = new THREE.Mesh(geometry, material);
        model.castShadow    = true;
        model.receiveShadow = true;

        geometry.computeBoundingBox();
        const center = geometry.boundingBox.getCenter(new THREE.Vector3());
        model.position.sub(center);
        scene.add(model);
        (window as any).stlModel = model;

        const box    = new THREE.Box3().setFromObject(model);
        const size   = box.getSize(new THREE.Vector3());
        const maxDim = Math.max(size.x, size.y, size.z);
        const fov    = camera.fov * (Math.PI / 180);
        const dist   = Math.abs(maxDim / 2 / Math.tan(fov / 2)) * 2;
        camera.position.set(dist, dist, dist);
        orbit.update();

        if (loading)  loading.style.display  = 'none';
        if (controls) controls.style.display = 'flex';
      },
      undefined,
      (err: any) => {
        console.error('STL load error:', err);
        if (loading) loading.innerHTML = '<p>Error loading 3D model.</p>';
      }
    );

    const animate = () => {
      requestAnimationFrame(animate);
      orbit.update();
      renderer.render(scene, camera);
    };
    animate();

    window.addEventListener('resize', () => {
      camera.aspect = container.clientWidth / container.clientHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(container.clientWidth, container.clientHeight);
    });
  }

  private registerStlGlobals() {
    (window as any).resetStlView = () => {
      const { stlModel, stlCamera, stlControls } = window as any;
      if (!stlModel || !stlCamera) return;
      const THREE = (window as any).THREE;
      const box  = new THREE.Box3().setFromObject(stlModel);
      const size = box.getSize(new THREE.Vector3());
      const max  = Math.max(size.x, size.y, size.z);
      const dist = Math.abs(max / 2 / Math.tan((stlCamera.fov * Math.PI / 180) / 2)) * 2;
      stlCamera.position.set(dist, dist, dist);
      stlControls.reset();
    };

    (window as any).toggleStlWireframe = () => {
      const m = (window as any).stlModel;
      if (m) m.material.wireframe = !m.material.wireframe;
    };

    (window as any).toggleStlAxes = () => {
      const a = (window as any).stlAxesHelper;
      if (a) a.visible = !a.visible;
    };
  }

}
